module.exports = __webpack_public_path__ + "media/background.a763008f.jpg";